import * as React from 'react';
import { Box } from '@seeneco-ui/core';


export type StandardPaddingsProps = {
	appearance?: 'horizontal' | 'vertical' | 'all';
};

const StandardPaddings: React.SFC<StandardPaddingsProps> = ({ appearance, children }) => {
	const paddingsMap = {
		'horizontal': '0 32px',
		'vertical': '24px 0',
		'all': '24px 32px',
	};

	return (
		<Box padding={paddingsMap[appearance]}>
			{children}
		</Box>
	);
}

StandardPaddings.displayName = 'StandardPaddings';
StandardPaddings.defaultProps = {
	appearance: 'all',
};

export default StandardPaddings;